export default __webpack_public_path__ + "static/media/ir.84e05fc1.svg";